import React, {useEffect} from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {Auth} from '@aws-amplify/auth';

import {useNavigate} from 'react-router-dom';

import {I18n} from '@aws-amplify/core';

import {deleteAccount, fetchAccounts, updateAccount,} from '../reducers/recordsSlice';

import {ErrorMessageComponent} from 'features/error-messages/hoc/ErrorMessageComponent';

import {accountsSelector} from 'features/accounts/selectors';

import {useErrorMessage} from 'hooks/useErrorMessage';

import ProfilesGrid from '../components/ProfilesGrid';

import {IndexPage as ReturnToComponent} from 'features/applications/pages/IndexPage';

import {Stack, Title} from '@mantine/core';

import styled from 'styled-components';

import {DisplayUserState} from 'components/DisplayUserState';

export const ButtonIconWrapper = styled.div`
  padding-top: 20%;
`;

export const IndexPage = () => {


    const navigate = useNavigate();

    const dispatch = useDispatch();

    const errorMessage = useErrorMessage();

    const accounts = useSelector((state) => accountsSelector(state));


    useEffect(() => {
        dispatch(fetchAccounts());
    }, []);


    const handleContinue = (account) => {
        Auth.configure({
                           userPoolId: account.cognitoUserPoolId,
                           userPoolWebClientId: account.appClientId,
                       });


        Auth.currentAuthenticatedUser().then(
            (user) => {
                navigate(`/redirect/${account.id}`);
            },
            (error) => {
                console.debug(
                    'LOGIN APP. ACCOUNTS INDEX PAGE. USER EXCEPTION: ',
                    error
                );
                navigate(`/method-selection/${account.id}`);
            }
        );
    };

    const handleSignOutAndForget = async (account) => {
        // forget account
        dispatch(deleteAccount(account.id));

        // sign out
        Auth.configure({
                           userPoolId: account.cognitoUserPoolId,
                           userPoolWebClientId: account.appClientId,
                       });

        // @see this - https://github.com/aws-amplify/amplify-js/issues/3540
        try {
            await Auth.signOut({global: true});
        } catch (e) {
            await Auth.signOut();
        }

        return false;
    };

    const handleSignOut = async (account) => {
        // sign out
        Auth.configure({
                           userPoolId: account.cognitoUserPoolId,
                           userPoolWebClientId: account.appClientId,
                       });

        try {
            await Auth.signOut({global: true});
        } catch (e) {
            await Auth.signOut();
        }
        return false;
    };

    const handleHideAccount = async (account) => {
        const updated = Object.assign({}, account, {isVisible: 'no'});
        dispatch(updateAccount({id: account.id, record: updated}));
        return false;
    };

    if (errorMessage) {
        return <ErrorMessageComponent error={errorMessage}/>;
    }


    return (
        <Stack spacing="xl">
            <Title order={4}>{I18n.get('Pick an account') + ':'}</Title>

            <ProfilesGrid
                accounts={accounts}
                handleContinue={handleContinue}
                handleSignOut={handleSignOut}
                handleSignOutAndForget={handleSignOutAndForget}
                handleHideAccount={handleHideAccount}
            />

            <ReturnToComponent/>

            {false && <DisplayUserState accounts={accounts}/>}
        </Stack>
    );
};
